import * as R from 'remeda';

export interface Mesh {
  id: number;
  type: string;
  preferredOrder: number;
}

export const sortByPreferredOrder: <T extends Mesh>(meshes: T[]) => T[] = R.sort((a, b) =>
  a.preferredOrder < b.preferredOrder ? -1 : 1,
);
